export default __webpack_public_path__ + "static/media/input_marvel.1733769a.png";